<!-- =========================================================================================
  File Name: ECommerceItemDetail.vue
  Description: eCommerce Item Detail page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="item-detail-page">
    <vs-alert
      color="danger"
      title="Error Fetching Product Data"
      :active.sync="error_occured"
    >
      <span>{{ error_msg }}. </span>
      <span>
        <span>Check </span
        ><router-link :to="{ name: 'ecommerce-shop' }" class="text-inherit underline"
          >All Items</router-link
        >
      </span>
    </vs-alert>
    <vx-card v-if="item_data[0]">
      <template slot="no-body" v-if="item_data.length > 0">
        <div class="item-content">
          <!-- Item Main Info -->
          <div class="product-details p-6">
            <b-row>
              <b-col lg="5" sm="12">
                <b-row>
                  <img
                    v-if="varyantlimi == 'true'"
                    v-img
                    :src="genelresim"
                    :alt="varyantStockName"
                    class="responsive"
                  />
                  <img
                    v-else
                    v-img
                    :src="sistemurl + item_data[0].image"
                    :alt="varyantStockName"
                    class="responsive"
                  />
                </b-row>
              </b-col>
              <b-col lg="7" sm="12">
                <h3>{{ varyantStockName }}</h3>

                <vs-divider style="margin-bottom: 7px" />
                <p class="flex items-center flex-wrap" v-if="varyantlimi == 'false'">
                  <span class="leading-none font-medium text-primary mr-4"
                    >Ürün Kodu:
                  </span>
                  {{ item_data[0].barcode }}
                </p>
                <p class="flex items-center flex-wrap" v-else>
                  <span class="leading-none font-medium text-primary mr-4"
                    >Ürün Kodu:
                  </span>
                  {{ varyantBarkod }}
                </p>
                <vs-divider style="margin: 7px" />
                <p v-if="item_data[0].stockCode" class="flex items-center flex-wrap">
                  <span class="leading-none font-medium text-primary mr-4"
                    >Stok Kodu:
                  </span>
                  {{ item_data[0].stockCode }}
                </p>
                <vs-divider
                  style="margin: 7px"
                  v-if="varyantlimi == 'true' && varyantStockSize"
                />
                <p
                  class="flex items-center flex-wrap"
                  v-if="varyantlimi == 'true' && varyantStockSize"
                >
                  <span class="leading-none font-medium text-primary mr-4">Ebat: </span>
                  {{ varyantStockSize }}
                </p>
                <vs-divider
                  style="margin: 7px"
                  v-if="varyantlimi == 'true' && varyantStockColor"
                />
                <p
                  class="flex items-center flex-wrap"
                  v-if="varyantlimi == 'true' && varyantStockColor"
                >
                  <span class="leading-none font-medium text-primary mr-4">Renk: </span>
                  {{ varyantStockColor }}
                </p>
                <vs-divider
                  style="margin: 7px"
                  v-if="varyantlimi == 'false' && quantity"
                />
                <p
                  class="flex items-center flex-wrap"
                  v-if="varyantlimi == 'false' && quantity"
                >
                  <span class="leading-none font-medium text-primary mr-4"
                    >Paket İçeriği:
                  </span>
                  {{ quantity }}
                </p>
                <vs-divider
                  style="margin: 7px"
                  v-if="varyantlimi == 'false' && item_data[0].stockUnit"
                />
                <p
                  class="flex items-center flex-wrap"
                  v-if="varyantlimi == 'false' && item_data[0].stockUnit"
                >
                  <span class="leading-none font-medium text-primary mr-4">Birim: </span>
                  {{ item_data[0].stockUnit }}
                </p>

                <p class="flex items-center flex-wrap" v-if="varyantlimi == 'false'">
                  <span class="leading-none font-medium text-primary mr-4">Adet: </span>
                  {{ item_data[0].quantity }}
                </p>
                <vs-divider style="margin: 7px" />
                <div style="margin-top: 60px" v-if="varyantlimi == 'true'" sm="12">
                  <b-form ref="form">
                    <b-row>
                      <b-col lg="12" v-if="!isMobile()">
                        <b-row>
                          <b-col lg="3">
                            <p></p>
                          </b-col>
                          <b-col lg="2">
                            <p>Özellik</p>
                          </b-col>
                          <b-col lg="2">
                            <p style="text-align: center">Adet</p>
                          </b-col>
                          <b-col lg="2">
                            <p style="text-align: center">Fiyat</p>
                          </b-col>
                          <b-col lg="2">
                            <p style="text-align: center">Tutar</p>
                          </b-col>
                        </b-row>
                      </b-col>
                      <hr />
                      <b-col lg="12" v-if="!isMobile()">
                        <b-row
                          align-v="center"
                          v-for="(item, index) in items"
                          :id="index"
                          :key="index"
                          ref="row"
                        >
                          <b-col lg="3" cols="3">
                            <b-form-group label-for="renk">
                              <blockquote
                                style="
                                  margin: 0px !important;
                                  padding-left: 15px;
                                  border-left: 4px solid #7367f0;
                                "
                              >
                                <img
                                  :src="sistemurl + item.image"
                                  :alt="item.stockName"
                                  style="width: 80px"
                                  class="grid-view-img px-4"
                                  @click="resimDegistir(item, sistemurl + item.image)"
                                />
                              </blockquote>
                            </b-form-group>
                          </b-col>
                          <b-col cols="2">
                            <p class="mb-0">{{ item.colorName }} - {{ item.size }}</p>
                          </b-col>

                          <b-col lg="2" v-if="item.quantity > 0">
                            <vs-input-number
                              v-model="item.qty"
                              @input="adetkontrol(item)"
                              v-b-tooltip.hover.bottom="
                                'Kalan depo adedi ' + item.quantity
                              "
                            />
                          </b-col>
                          <b-col lg="2" v-else>
                            <blockquote style="text-align: center">
                              <p class="mb-0">TÜKENDİ</p>
                            </blockquote>
                          </b-col>
                          <b-col lg="2">
                            <blockquote style="text-align: center">
                              <p class="mb-0">{{ fixedTutar(item.fiyat) }} (KDV hariç)</p>
                            </blockquote>
                          </b-col>

                          <b-col lg="2">
                            <blockquote style="text-align: center">
                              <p class="mb-0">
                                {{ fixedTutar(item.fiyat * item.qty) }}
                              </p>
                            </blockquote>
                          </b-col>

                          <b-col lg="1" class="mb-50">
                            <b-row style="padding: 0">
                              <b-col style="padding: 0" v-if="item.disable == false">
                                <feather-icon
                                  icon="CheckIcon"
                                  class="cursor-pointer"
                                  svgClasses="w-7 h-7"
                                  style="color: green"
                                  @click="addItem(index)"
                                />
                              </b-col>
                            </b-row>
                          </b-col>
                          <b-col cols="12">
                            <hr />
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col lg="12" v-else>
                        <b-row
                          align-v="center"
                          v-for="(item, index) in items"
                          :id="index"
                          :key="index"
                          ref="row"
                        >
                          <b-col cols="4">
                            <b-form-group label-for="renk">
                              <blockquote
                                style="
                                  margin: 0px !important;
                                  border-left: 4px solid #7367f0;
                                "
                              >
                                <img
                                  :src="sistemurl + item.image"
                                  :alt="item.stockName"
                                  style="width: 80px"
                                  class="grid-view-img px-4"
                                  @click="resimDegistir(item, sistemurl + item.image)"
                                />
                              </blockquote>
                            </b-form-group>
                          </b-col>
                          <b-col cols="8">
                            <p class="mb-0">{{ item.colorName }} - {{ item.size }}</p>
                          </b-col>

                          <b-col cols="4" v-if="item.quantity > 0">
                            <vs-input-number
                              v-model="item.qty"
                              @input="adetkontrol(item)"
                              v-b-tooltip.hover.bottom="
                                'Kalan depo adedi ' + item.quantity
                              "
                            />
                          </b-col>
                          <b-col cols="4" v-else>
                            <blockquote style="text-align: center">
                              <p class="mb-0">TÜKENDİ</p>
                            </blockquote>
                          </b-col>
                          <b-col cols="4">
                            <blockquote style="text-align: center">
                              <p class="mb-0">{{ fixedTutar(item.fiyat) }} (KDV hariç)</p>
                            </blockquote>
                          </b-col>
                          <b-col cols="4">
                            <blockquote style="text-align: center">
                              <p class="mb-0">
                                {{ fixedTutar(item.fiyat * item.qty) }}
                              </p>
                            </blockquote>
                          </b-col>

                          <b-col cols="12">
                            <hr />
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-form>
                </div>

                <p
                  class="flex items-center flex-wrap"
                  style="margin-bottom: 15px"
                  v-if="varyantlimi == 'true'"
                >
                  <span class="text-2xl leading-none font-medium text-primary mr-4 mt-2"
                    >{{ fixedTutar(toplamTutarVaryant) }}
                  </span>
                </p>
                <p class="flex items-center flex-wrap" style="margin-bottom: 15px" v-else>
                  <span class="text-2xl leading-none font-medium text-primary mr-4 mt-2"
                    >{{ item_data[0].price }} {{ item_data[0].currency }}
                  </span>
                </p>

                <!-- Quantity -->
                <div
                  class="vx-row"
                  style="margin-top: 50px"
                  v-if="isAuth && isAuth != null && isAuth != 'null'"
                >
                  <div class="vx-col w-full">
                    <div
                      class="flex flex-wrap items-start mb-4"
                      v-if="varyantlimi == 'true'"
                    >
                      <!-- Add To Cart Button -->
                      <vs-button
                        class="mr-4"
                        icon-pack="feather"
                        icon="icon-shopping-cart"
                        @click="toggleItemInCart(item_data[0])"
                      >
                        SEPETE EKLE
                      </vs-button>
                      <!-- /Add To Cart Button -->
                    </div>
                    <div class="flex flex-wrap items-start mb-4" v-else>
                      <!-- Add To Cart Button -->
                      <vs-button
                        class="mr-4"
                        icon-pack="feather"
                        icon="icon-shopping-cart"
                        v-if="
                          item_data[0].quantity > 0 && !isInCart(item_data[0].barcode)
                        "
                        @click="toggleItemInCart(item_data[0])"
                      >
                        SEPETE EKLE
                      </vs-button>

                      <vs-button
                        v-if="item_data[0].quantity > 0 && isInCart(item_data[0].barcode)"
                        class="mr-4 mb-4"
                        icon-pack="feather"
                        icon="icon-shopping-cart"
                        @click="
                          $router.push({ name: 'products-checkout' }).catch((err) => {})
                        "
                      >
                        SEPETTE GÖRÜNTÜLE
                      </vs-button>
                      <vs-button
                        style="pointer-events: none"
                        class="text-sm font-semibold ml-2"
                        v-if="item_data[0].quantity <= 0"
                        >TÜKENDİ</vs-button
                      >
                      <!-- /Add To Cart Button -->
                    </div>
                  </div>
                </div>
                <div class="vx-row" style="margin-top: 50px" v-else>
                  <div class="vx-col w-full">
                    <div
                      class="flex flex-wrap items-start mb-4"
                      v-if="varyantlimi == 'true'"
                    >
                      <!-- Add To Cart Button -->
                      <vs-button
                        class="mr-4"
                        icon-pack="feather"
                        icon="icon-shopping-cart"
                        @click="goToLogin()"
                      >
                        SEPETE EKLE
                      </vs-button>

                      <!-- /Add To Cart Button -->
                    </div>
                    <div class="flex flex-wrap items-start mb-4" v-else>
                      <!-- Add To Cart Button -->
                      <vs-button
                        class="mr-4"
                        icon-pack="feather"
                        icon="icon-shopping-cart"
                        v-if="item_data[0].quantity > 0"
                        @click="goToLogin()"
                      >
                        SEPETE EKLE
                      </vs-button>
                      <vs-button
                        style="pointer-events: none"
                        class="text-sm font-semibold ml-2"
                        v-if="item_data[0].quantity <= 0"
                        >TÜKENDİ</vs-button
                      >
                      <!-- /Add To Cart Button -->
                    </div>
                  </div>
                </div>
                <div class="vx-row mt-6">
                  <b-card header="Özellik" style="width: 100%">
                    <div class="vx-col md:w-5/5 w-full flex items-center justify-center">
                      <b-card-text>
                        <p v-if="trimDetails != null" v-html="parsedBody"></p>
                      </b-card-text>
                    </div>
                  </b-card>
                </div>
              </b-col>
            </b-row>
            <div class="vx-row mt-6">
              <div class="vx-col md:w-2/5 w-full flex items-center justify-center">
                <div class="product-img-container w-3/5 mx-auto mb-10 md:mb-0"></div>
              </div>

              <!-- Item Content -->
              <div class="vx-col md:w-3/5 w-full">
                <!-- /Quantity -->
              </div>
            </div>
          </div>
        </div>
      </template>
    </vx-card>
    <b-modal
      ref="modal-primary"
      id="modal-primary"
      modal-class="modal-primary"
      centered
      size="xl"
      hide-header
      hide-title
      hide-footer
    >
      <div id="invoice-page">
        <div class="items-center justify-between">
          <LOGIN :loginTanim="loginTanim" />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { VBTooltip, BFormSpinbutton } from "bootstrap-vue";
import "swiper/swiper.min.css";
import "swiper/swiper-bundle.css";
import { swiper, swiperSlide, directive } from "vue-awesome-swiper";
import LOGIN from "../pages/Login.vue";
import algoliasearch from "algoliasearch/lite";
import StarRating from "vue-star-rating";
import Store from "../../store/store";
import state from "../../store/state";
import VueZoomer from "vue-zoomer";
import userJson from "../../../public/user.json";
import { isMobile } from "mobile-device-detect";
import store from "../../store/store";
export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    LOGIN,
    BFormSpinbutton,
    swiper,
    swiperSlide,
    StarRating,
    VZoomer: VueZoomer.Zoomer,
    VZoomerGallery: VueZoomer.Gallery,
  },
  data() {
    return {
      isAuth: Store.state.tokenId,
      loginTanim: true,
      musteriTanim: "",
      urlItem: "",
      varyantBarkod: "",
      varyantStockName: "",
      varyantStockSize: "",
      varyantStockColor: "",
      items: [],
      genelresim: "",
      sistemurl: "",
      varyantlimi: userJson.varyant,

      trimDetails: "",
      detailsTrim: "",
      colorName: "",
      size: "",
      quantity: 0,
      productPrice: 0,
      algolia_index: algoliasearch(
        "latency",
        "6be0576ff61c053d5f9a3225e2a90f76"
      ).initIndex("instant_search"),
      item_data: [],
      error_occured: false,
      error_msg: "",

      // Related Products Swiper
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 55,
        breakpoints: {
          1600: {
            slidesPerView: 4,
            spaceBetween: 55,
          },
          1300: {
            slidesPerView: 3,
            spaceBetween: 55,
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 55,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 55,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },

      // Below is data which is common in any item
      // Algolia's dataSet don't provide this kind of data. So, here's dummy data for demo
      available_item_colors: ["#7367F0", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"],
      opt_color: "#7367F0",
      is_hearted: false,
    };
  },
  computed: {
    customerId: {
      get() {
        return this.$store.state.UserId;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    stocks: {
      get() {
        return this.$store.state.eCommerce.StockList;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    stocksVaryant: {
      get() {
        return this.$store.state.eCommerce.StockListVaryant;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    userPriceType: {
      get() {
        return this.$store.state.userPriceType;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    parsedBody() {
      return this.trimDetails.replace(/\n/g, "<br>");
    },

    isInCart() {
      return (itemId) => this.$store.getters["eCommerce/isInCart"](itemId);
    },

    toplamTutarVaryant() {
      var toplanan = 0.0;
      this.items.forEach((val, index) => {
        if (val.qty > 0) {
          toplanan += val.fiyat * val.qty;
        }
      });
      return toplanan;
    },
  },
  watch: {
    customerId(val) {
      return val;
    },
    userPriceType(val) {
      return val;
    },
    stocksVaryant(val) {
      this.item_data = val;
      this.genelresim = this.sistemurl + this.item_data[0].image;
      this.varyantBarkod = this.item_data[0].barcode;
      this.varyantStockName = this.item_data[0].stockName;
      this.varyantStockSize = this.item_data[0].size;
      this.varyantStockColor = this.item_data[0].colorName;
      this.items = [];
      this.item_data.forEach((val, index) => {
        this.items.push({
          discount: val.iskonto1,
          stockQuantity: val.stockQuantity,
          status: val.ONAY,
          unit: val.unit,
          ONAY: val.ONAY,
          adresId: val.adresId,
          kdv: val.vat,
          qty: 0,
          stockName: val.stockName,
          size: val.size,
          colorName: val.colorName,
          fiyat: val.price,
          tutar: val.tutar,
          image: val.image,
          quantity: val.quantity,
          barcode: val.barcode,
          stockCode: val.stockCode,
          renkKodu: val.colorCode,
        });
      });
      //	this.fetch_item_details();
      return val;
    },
  },
  methods: {
    goToLogin() {
      this.$refs["modal-primary"].show();
    },
    isMobile: function () {
      return isMobile;
    },
    fixedTutar(tutar) {
      var parsedtutar = parseFloat(tutar);
      return parsedtutar.toLocaleString("tr-TR", {
        style: "currency",
        currency: "TRY",
      });
    },
    adetkontrol(item) {
      if (userJson.eksiliStok == false) {
        if (item.qty > item.quantity) {
          var vs = this.$vs;
          vs.notify({
            title: "Uyarı",
            text: "Seçilen adet, depo stoğundan büyük olamaz",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
          item.qty = item.quantity;
        }
      }
    },
    resimDegistir(item, val) {
      this.genelresim = val;
      this.varyantBarkod = item.barcode.toString();
      this.varyantStockName = item.stockName;
      this.varyantStockSize = item.size;
      this.varyantStockColor = item.colorName;
    },

    toggleItemInCart(item) {
      var vm = this;
      if (vm.varyantlimi == "true") {
        var sepetek = [];

        vm.items.forEach((val, index) => {
          if (val.qty > 0) {
            sepetek.push({
              discount: val.iskonto1,
              image: val.image,
              stockQuantity: val.stockQuantity,
              status: val.ONAY,
              unit: parseFloat(val.unit) == 0 ? 1 : val.unit,

              quantity: val.qty,
              colorName: val.colorName,
              size: val.size,
              price: val.fiyat,
              barcode: val.barcode,
              productCode: val.stockCode,
              productName: val.stockName,
              ONAY: val.ONAY,
              adresId: val.adresId,
              kdv: val.kdv,

              customerCode: this.$store.state.UserId,
            });
          }
        });
        sepetek.forEach((value, index) => {
          /*
						if (item[index].quantity == 0) {
						  
							vs.notify({
								text:
									item[index].stockCode + "kodlu ürün stokta bulunmamaktadır",
								iconPack: "feather",
								icon: "icon-alert-circle",
								color: "danger",
								position: "top-center",
							});
						}*/
          this.$store.dispatch("eCommerce/additemInCartToplu", value).then((response) => {
            if (response == "ok") {
              var vs = this.$vs;
              vs.notify({
                title: "Başarılı",
                text: "Seçilen ürünler sepete eklendi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              //    vm.fetch_item_details();
            }
          });
        });
      } else {
        var args = {
          discount: item.iskonto1,
          image: item.image,
          stockQuantity: item.stockQuantity,
          unit: item.unit,

          colorName: item.colorName,

          price: item.fiyat,

          adresId: item.adresId,
          kdv: item.kdv,

          customerCode: this.$store.state.UserId,

          barcode: item.barcode,
          productCode: item.stockCode,
          productName: item.stockName.replace("'", ""),
          vat: parseInt(item.kdv),
          ISKONTO: 0,
          ADET: 1,
          price: item.price,
          ONAY: "",
          quantity: 1,
        };
        vm.isInCart(item.barcode)
          ? vm.$router.push("/products/checkout").catch(() => {})
          : vm.$store.dispatch("eCommerce/additemInCart", args).then((response) => {
              if (response == "ok") {
                //  vm.fetch_item_details();
              }
            });
      }
    },
    fetch_item_details() {
      var vm = this;
      vm.item_data = [];
      const soap = require("soap");
      const url = state.sistemAddress;
      /*
			if (userJson.varyant == "true") {
			 
				console.log(vm.stocksVaryant)
				let itemData2 = [vm.stocksVaryant.filter(d => d.stockCode === vm.urlItem)]
				vm.item_data = itemData2[0]
				vm.genelresim = vm.sistemurl + vm.item_data[0].image;
				vm.varyantBarkod = vm.item_data[0].barcode;
				vm.items = [];
				vm.item_data.forEach((val, index) => {
					vm.items.push({
						qty: 0,
						stockName: val.stockName,
						size: val.size,
						colorName: val.colorName,
						fiyat: val.price,
						tutar: val.tutar,
						image: val.image,
						quantity: val.quantity,
						barcode: val.barcode,
						stockCode: val.stockCode,
						renkKodu: val.renkKodu
					});
				});
console.log(vm.item_data)
			} else {
*/
      let args = {
        token: state.tokenId,
        KATEGORI: "",
        ARANAN: vm.urlItem,
        ILKKAYIT: 0,
        SONKAYIT: 100000000,
        EKSORGU: "",
        ACTID: this.customerId,
        userPriceType: this.userPriceType,
        priceType: userJson.priceType,
      };
      console.log(args)

      this.$store.dispatch("getDataStockVaryant", args).then((response) => {
        if (response == "-1") {
        } else {
        }
      });
    },
    //		}
  },
  mounted() {
    //tables global olarak tanımlanıyor
    this.$root.$on("toggleItemInCart22", (params) => {
      this.toggleItemInCart();
    });
  },
  beforeDestroy() {
    this.$root.$off("toggleItemInCart22");
  },
  created() {
    document.documentElement.style.setProperty("--main-bg-color", userJson.themeColor);
    this.sistemurl = userJson.resimUrl;
    this.urlItem = this.$route.params.item_id;

    this.fetch_item_details();
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/_variables.scss";

#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}

.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}

:root {
  /* default value */
  --main-bg-color: brown;
}

[dir] blockquote {
  border-left-color: var(--main-bg-color) !important;
}

.fullscreen-v-img[data-v-5928e1c7] {
  z-index: 99999;
}

#item-detail-page {
  .color-radio {
    height: 2.28rem;
    width: 2.28rem;

    > div {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .item-features {
    background-color: #f7f7f7;

    .theme-dark & {
      background-color: $theme-dark-secondary-bg;
    }
  }

  .product-sales-meta-list {
    .vs-list--icon {
      padding-left: 0;
    }
  }

  .related-product-swiper {
    // padding-right: 2rem;
    // padding-left: 2rem;

    .swiper-wrapper {
      padding-bottom: 2rem;

      > .swiper-slide {
        background-color: #f7f7f7;
        box-shadow: 0 4px 18px 0 rgba(0, 0, 0, 0.1), 0 5px 12px 0 rgba(0, 0, 0, 0.08) !important;

        .theme-dark & {
          background-color: $theme-light-dark-bg;
        }
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      transform: scale(0.5);
      filter: hue-rotate(40deg);
    }

    .swiper-button-next {
      right: 0;
    }

    .swiper-button-prev {
      left: 0;
    }
  }
}
</style>
